<div *ngFor="let video of videos; let i = index" class="video {{classList}}"
  [title]="!functionalCookies ? ('general.cookiesContentDisabled'|translate) : null" (click)="loadVideo(video)">

  @if (video.thumbnail) {
  <img class="thumbnail" [class.disabled]="!functionalCookies" [src]="video.thumbnail" [alt]="video.title"
    loading="lazy">
  } @else {
  <img src="../../../../assets/img/video.svg" alt="ico" class="thumbnail" [class.disabled]="!functionalCookies"
    loading="lazy">
  }

  <mat-icon class="play-icon" [class.disabled]="!functionalCookies">play_arrow</mat-icon>
</div>